import React from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { useSelector } from "react-redux";

const Error404 = () => {
  const translation = useSelector(state => state.root.translation);
  const route = all_routes;
  return (
    <div className="main-wrapper">
      <div className="error-box">
        <div className="error-img">
          <ImageWithBasePath
            src="assets/img/authentication/error-404.png"
            className="img-fluid"
            alt
          />
        </div>
        <h3 className="h2 mb-3">{translation["oops,_something_went_wrong"]}</h3>
        <p>
          {translation["error_404_page_not_found._sorry_the_page_you_looking_for_doesn’t_exist_or_has_been_moved"]}
        </p>
        <Link to={route.dashboard} className="btn btn-primary">
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default Error404;
